module.exports = __webpack_public_path__ + "static/media/building.2212b50f.svg";